<template>
  <b-card class="px-3 py-5 p-md-5" no-body>
    <div class="form-side">
      <slot name="header"></slot>

      <h6 class="mb-4">{{ title }}</h6>

      <b-form @submit.prevent="handleSubmit" :novalidate="true">
        <slot name="fields"></slot>

        <div class="d-flex justify-content-between align-items-center">
          <transition name="fade" mode="out-in">
            <b-button
              :disabled="submitStatus === 'PENDING'"
              type="submit"
              variant="primary"
              class="btn-shadow"
              :class="{'btn-block' : (btnBlock)}"
            >
              <span v-if="!loading">{{ action }}</span>
              <span class="spinner d-inline-block" v-if="loading">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
            </b-button>
          </transition>
        </div>

        <slot name="buttons"></slot>

        <transition name="fade" mode="in-out">
          <b-alert show variant="danger" class="mt-3" v-if="errors.length > 0">
            <ul>
              <li v-for="error in errors" :key="error">{{ error }}</li>
            </ul>
          </b-alert>
        </transition>

        <slot name="footer"></slot>
      </b-form>
    </div>
  </b-card>
</template>

<script>
export default {
  props: ["title", "action", "errors", "loading", "submitStatus", "btnBlock"],

  methods: {
    handleSubmit() {
      this.$emit("handleSubmit");
    }
  }
};
</script>

<style>
</style>
